import "./faq-label.styles.css";
import { FaChevronDown } from "react-icons/fa6";
import { useState } from "react";

const FaqLabel = ({category}) => {
    // State برای مدیریت باز یا بسته بودن پاسخ
    const [isOpen, setIsOpen] = useState(false);

    // تابعی برای تغییر وضعیت باز یا بسته بودن پاسخ
    const toggleAnswer = () => {
        setIsOpen(!isOpen);
    }

    const {qusetion ,answer} = category;

    return (
        <div className={`faq-label-container ${isOpen ? 'open' : ''}`}>
            {/* با کلیک روی سوال، تابع toggleAnswer فراخوانی می‌شود */}
            <h4 className="faq-label-question" onClick={toggleAnswer}>
                {qusetion}
                <span><FaChevronDown className={`faq-label-icon ${isOpen ? 'rotated' : ''}`} /></span>
            </h4>
            {/* پاسخ را داخل یک div می‌گذاریم تا از max-height و transition استفاده کنیم */}
            <div className={`faq-label-answer-container ${isOpen ? 'open' : ''}`}>
                <p className="faq-label-answer">
                    {answer}
                </p>
            </div>
        </div>
    );
}

export default FaqLabel;
